
import Vue from 'vue';
import { HistoryRouter, Redirect, Route } from 'vue-component-router';
import ScriptLoader from '@/components/ScriptLoader.vue';

export default Vue.extend({
  name: 'App',
  components: {
    HistoryRouter,
    Redirect,
    Route,
    ScriptLoader
  }
});
